import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'Ventures', href: '/ventures' },
    { label: 'Team', href: '/team' },
    { label: 'Impact', href: '/impact' },
    { label: 'Press', href: '/press' },
    { label: 'Contact', href: '/contact' },
  ];

  return (
    <header className={`prisma-nav ${scrolled ? 'scrolled' : ''}`} data-testid="navbar">
      <div className="nav-inner">
        <div className="nav-logo" onClick={() => navigate('/')} data-testid="nav-logo">
          <img src="/prisma-logo-white.png" alt="The Prisma Global" className="nav-logo-img" />
        </div>

        <nav className={`nav-links ${mobileOpen ? 'open' : ''}`} data-testid="nav-links">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className={`nav-link ${location.pathname === link.href ? 'active' : ''}`}
              onClick={() => setMobileOpen(false)}
              data-testid={`nav-link-${link.label.toLowerCase().replace(' ', '-')}`}
            >
              {link.label}
            </a>
          ))}
          <a
            href="mailto:hello@theprismaglobal.com?subject=Prisma%20Studio%20Conversation"
            className="nav-studio-btn"
            data-testid="nav-studio-btn"
            onClick={() => setMobileOpen(false)}
          >
            Explore Studio
          </a>
        </nav>

        <button
          className={`nav-toggle ${mobileOpen ? 'open' : ''}`}
          onClick={() => setMobileOpen(!mobileOpen)}
          data-testid="nav-toggle"
          aria-label="Toggle menu"
        >
          <span />
          <span />
        </button>
      </div>
    </header>
  );
};

export default Navbar;
